/**
 * Dashboard de Projetos - Métricas resumidas
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Ship, Calendar, DollarSign, AlertTriangle, CheckCircle2, Clock } from 'lucide-react';

const DashboardProjetos = ({ projetos }) => {
  // Calcular métricas
  const totalProjetos = projetos.length;
  const emProducao = projetos.filter(p => p.status === 'em_producao' || p.status === 'In Progress').length;
  const emAtraso = projetos.filter(p => p.status === 'em_atraso').length;
  const concluidos = projetos.filter(p => p.status === 'concluido' || p.status === 'Completed').length;
  const totalBudget = projetos.reduce((acc, p) => acc + (p.valor_venda ?? p.budget ?? 0), 0);
  
  // Entregas próximas (30 dias)
  const hoje = new Date();
  const em30dias = new Date(hoje.getTime() + 30 * 24 * 60 * 60 * 1000);
  const entregasProximas = projetos.filter(p => {
    if (!p.delivery_date) return false;
    const delivery = new Date(p.delivery_date);
    return delivery >= hoje && delivery <= em30dias && p.status !== 'concluido' && p.status !== 'Completed';
  }).length;

  const cards = [
    {
      title: 'Total de Projetos',
      value: totalProjetos,
      icon: Ship,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      title: 'Em Produção',
      value: emProducao,
      icon: Clock,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50'
    },
    {
      title: 'Em Atraso',
      value: emAtraso,
      icon: AlertTriangle,
      color: emAtraso > 0 ? 'text-red-600' : 'text-gray-400',
      bgColor: emAtraso > 0 ? 'bg-red-50' : 'bg-gray-50'
    },
    {
      title: 'Entregas em 30 dias',
      value: entregasProximas,
      icon: Calendar,
      color: entregasProximas > 0 ? 'text-orange-600' : 'text-gray-400',
      bgColor: entregasProximas > 0 ? 'bg-orange-50' : 'bg-gray-50'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {cards.map((card, index) => (
        <Card key={index} className={`${card.bgColor} border-0`}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-gray-500 uppercase tracking-wide">{card.title}</p>
                <p className={`text-2xl font-bold ${card.color} mt-1`}>
                  {card.value}
                </p>
              </div>
              <card.icon className={`h-8 w-8 ${card.color} opacity-50`} />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default DashboardProjetos;
